import CookieBanner from "./modules/cookie-banner";
CookieBanner();

const Nav = require("bluegg-nav");

var mainNav = new Nav({
  nav: "#primary-nav",
  trigger: "#primary-nav-trigger",
});

// Contact form stuff
const parsley = require("parsleyjs");
const $ = require("jquery");

var msgForm = $("#message-form");

$("[data-type-chooser]").each(function () {
  $(this).on("click", chooseUserType);
});

function chooseUserType() {
  msgForm.parsley().reset();

  // var form     = document.getElementById('message-form');
  var userType = $(this).data("type-chooser");
  msgForm.attr("data-user-type", userType);

  // Unset required on other type fields first
  var otherType = userType == "client" ? "candidate" : "client";

  $('[data-type="' + otherType + '"] input').each(function () {
    $(this).removeAttr("required");
  });

  // Set required on chosen type fields
  $('[data-type="' + userType + '"] input').each(function () {
    $(this).attr("required", "required");
  });

  var msgFld = $("#message");
  var msgFldPlaceholder = "";

  switch (userType) {
    case "client":
      msgFldPlaceholder = "Let us know what type of person you’re looking for";
      break;

    case "candidate":
      msgFldPlaceholder =
        "Let us know what type of position you're looking for";
  }

  msgFld.attr("placeholder", msgFldPlaceholder);

  // Add tab param to url
  window.history.pushState({}, "", "?tab=" + userType);
}

var validation = msgForm.parsley({
  errorsContainer: function (e) {
    return e.$element.parents(".form-control").find(".form-control__errors");
  },
  errorsWrapper: '<ul class="form-errors"></ul>',
  errorTemplate: '<li class="form-errors__item"></li>',
  classHandler: function (e) {
    return e.$element.parents(".form-control");
  },
  errorClass: "form-control--error",
});

msgForm.find("button").on("click", function (e) {
  e.preventDefault();

  $(this).attr("disabled", "disabled");
  var _this = $(this);

  setTimeout(function () {
    msgForm.submit();

    if (validation.isValid() == false) {
      _this.removeAttr("disabled");
    }
  }, 1);
});

// FITVIDS - For making embedded videos fill width of container
const Fitvids = require("fitvids");

Fitvids(".figure--video .figure__media");
